module.exports = __webpack_public_path__ + "static/media/SmartWork_Vertical_App.4f0d6ef6.png";